import Page from "~/pages/Page";
import "~/globals";
import $ from "jquery";
import UI from "~/ui";
import { gotoLogin } from "~/utils";
import { getApi, handleError } from "~/auth";
import { initTablePlus } from '~/tablePlus';
import { t } from "~/hooks/useI18n";

// ✅ Importa utility validazione file
import {
    ALLOWED_FILE_EXTENSIONS,
    validateAndShowFileError,
    getFileExtension,
    validateFile,
    formatFileSize,
    showFileError,
    clearFileError,
    showCustomFileError,
    clearCustomFileError,
    validateMaskedFileInputWithBorder
} from "~/utils/fileValidation";
class Documenti extends Page {
    private auth: any = null;
    private UserId: number = 0; // Aggiungi l'ID dell'utente
    private userInfo: any = null; // Variabile globale per memorizzare le informazioni dell'utente
    private venditaId: number = 0;
    private maxBytesUploadAllegati: number = 8 * 1024 * 1024; // 8MiB
    private message: string | undefined;

    /**
     * Restituisce la lista di file selezionati dall'input element
     */
    private getUploadFiles(): File[] {
        const el = document.getElementById("uploadDocumenti") as HTMLInputElement | null;
        if (!el || !el.files) return [];
        return Array.from(el.files);
    }

    constructor() {
        super("Documenti", "Documenti venditore");
    }


    pageStart(): Promise<void> {
        const that = this;
        this.auth = getApi();
        this.userInfo = this.auth.getCached("userInfo"); // Inizializza la variabile globale
        if (!this.userInfo) {
            gotoLogin();
            return Promise.reject("User not authenticated");
        }

        this.UserId = this.userInfo.anagraficaId; // Inizializza l'ID dell'utente

        initTablePlus();

        //window.bsCustomFileInput.init();

        this.InitUpload();

        return Promise.resolve();
    }

    private InitUpload() {

        $("#btnUploadDocumenti").on("click", (e: any) => {
            e.preventDefault();

            const fileList = this.getUploadFiles();
            const ddlValue = $("#ddlAllegati").val() as string;

            // ✅ Validazioni preliminari
            if (fileList.length === 0) {
                UI.confirmOneButton("", t("messages.selectFile") || "Selezionare un file");
                return;
            }

            if (!ddlValue) {
                UI.confirmOneButton("", t("messages.selectDocumentType") || "Indicare il tipo di documento");
                return;
            }

            // ✅ Configurazione estensioni per tipo documento
            // FO = Foto, PL = Planimetria → solo immagini
            // Altri tipi → tutti i file consentiti
            const allowedExtensionsForType: string[] = (ddlValue === "FO" || ddlValue === "PL")
                ? [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"]
                : Array.from(ALLOWED_FILE_EXTENSIONS); // Converti readonly array a string[]

            // ✅ Validazione TUTTI i file selezionati
            const errors: string[] = [];

            fileList.forEach((file) => {
                const extension = getFileExtension(file.name);

                // Valida con modulo centralizzato
                const validationResult = validateFile(file, this.maxBytesUploadAllegati);

                if (!validationResult.isValid) {
                    errors.push(`<strong>${file.name}</strong>: ${validationResult.errorMessage}`);
                    return;
                }

                // Controllo aggiuntivo per tipo documento specifico
                if (allowedExtensionsForType.indexOf(extension) === -1) {
                    const allowedList = allowedExtensionsForType.join(", ");
                    errors.push(
                        `<strong>${file.name}</strong>: Estensione ${extension} non consentita per questo tipo di documento. ` +
                        `Estensioni consentite: ${allowedList}`
                    );
                }
            });

            // ✅ Mostra errori o procedi con upload
            if (errors.length > 0) {
                UI.confirmOneButton("", errors.join("<br/>"));
            } else {
                this.UploadDocumentoPratica();
            }
        });

        // ✅ Validazione real-time al cambio file
        $("#uploadDocumenti").on("change", function () {
            const fileInput = this as HTMLInputElement;
            if (fileInput.files && fileInput.files.length > 0) {
                validateAndShowFileError(fileInput, fileInput.files[0]);
                $("#btnUploadDocumenti").removeAttr("disabled");
            }
        });

    }

    private async UploadDocumentoPratica(): Promise<any> {
        const files = this.getUploadFiles();

        if (files.length === 0) {
            UI.confirmOneButton("", "Selezionare un file");
            return;
        }

        const formData = new FormData();

        // Appendi i file usando il nome del file come chiave (come nel codice originale)
        files.forEach((file: File) => {
            formData.append(file.name, file);
        });

        formData.append("TipoAllegato", $("#ddlAllegati").val() as string);
        formData.append("LottoId", $("#LottoId").val() as string);

        console.log("FormData contents:");
        for (let pair of (formData as any).entries()) {
            console.log(pair[0] + ': ' + (pair[1] instanceof File ? pair[1].name : pair[1]));
        }

        this.spinner.spin();

        try {
            const url = window.BaseUrlWebApi + "Allegato/UploadDocumentoPraticaAsync";

            const response = await fetch(url, {
                method: 'POST',
                body: formData,
                credentials: 'include',  // ✅ Includi i cookie per l'autenticazione
                // ❌ NON specificare Content-Type - il browser lo imposta automaticamente con il boundary corretto per multipart/form-data
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error("Errore upload documento gara:", errorText);
                let msg: string;
                try {
                    msg = JSON.parse(errorText).Message ?? errorText;
                } catch {
                    msg = errorText;
                }
                UI.confirmOneButton("", msg);

                return;
                //return { success: false, message: errorText || "Errore durante il caricamento del documento" };
            }

            const result = await response.json();
            console.log("Documento caricato con successo.", result);
            // ✅ Recupera la lista di allegati dalla risposta
            const listAllegati = result.ListAllegati || [];
            const message = result.Message || "";

            console.log(`Upload completato: ${message}`, listAllegati);

            if (typeof (result) === "string") {
                // c'è stata una eccezione gestita lato backend
                UI.confirmOneButton("", result);
                return;
            }

            // ✅ Usa listAllegati invece di result
            if (listAllegati.length === 0) {
                UI.confirmOneButton("", "Nessun allegato caricato");
                return;
            }

            // Invia email di notifica (non blocca il flusso se fallisce)
            //this.InviaMail(model).catch(err => {
            //    console.error("Errore invio email:", err);
            //});

            // Reset completo del form
            const uploadForm = document.getElementById("frmUploadDocumenti") as HTMLFormElement | null;
            if (uploadForm) {
                uploadForm.reset();
            }

            // Resetta il dropdown tipo allegato
            $("#ddlAllegati").val("");

            // Disabilita il pulsante upload
            $("#btnUploadDocumenti").attr("disabled", "disabled");


            $("div.messageallegati").html("");

            // ✅ Aggiungi tutte le nuove righe alla tabella (supporta upload multiplo)
            for (const allegato of listAllegati) {
                await this.AppendRowDocumento([allegato]);
            }

            UI.confirmOneButton("", message || "Allegati caricati correttamente");

        } catch (err: any) {
            console.error("Upload error:", err);
            UI.confirmOneButton("", err.message || "Errore durante l'upload del file");

        } finally {
            this.spinner.stop();
        }
    }

    private async AppendRowDocumento(data: any): Promise<any> {
        console.info("DATA -->" + data);
        const Id = data[0]["Id"];
        const LottoId = data[0]["LottoId"];
        const NomeFile = data[0]["NomeFile"];
        const NomeFileOriginale = data[0]["NomeFileOriginale"];
        const TipoAllegato = data[0]["TipoAllegato"].Descrizione;

        let allegatoRow: string = "";
        allegatoRow += "<tr id='trrow" + Id + "'>";
        allegatoRow += "    <td data-label='Allegato'>";
        allegatoRow += TipoAllegato;
        allegatoRow += "    </td>";
        allegatoRow += "    <td data-label='Nome file originale'>";
        allegatoRow += "        <div class='d-flex justify-content-end justify-content-md-start'>";
        allegatoRow += "            <a href='image/GetData?id=" + LottoId + "&name=" + NomeFile + "' target='_blank'>";
        allegatoRow += "                <code>" + NomeFileOriginale + "</code>";
        allegatoRow += "            </a>";
        allegatoRow += "        </div>";
        allegatoRow += "    </td>";
        allegatoRow += "    <td data-label='Data inserimento'>";
        allegatoRow += "        <div class='d-flex justify-content-end justify-content-md-start'>";
        allegatoRow += "          <a href='#' class='btn btn-primary rowAllegatoCommandDelete' data-rif-id='" + Id + "'data-rif-lottoId='" + LottoId + "'>";
        allegatoRow += "              <span>Elimina</span>";
        allegatoRow += "              <span class='material-symbols-outlined'>delete</span>";
        allegatoRow += "          </a>";
        allegatoRow += "        </div>";
        allegatoRow += "    </td>";
        allegatoRow += "</tr>";

        $("#tbDocumenti").removeClass("d-none");

        const that = this; // Salva il riferimento alla classe

        $(allegatoRow)
            .prependTo($("#tbDocumenti tbody"))
            .find(".rowAllegatoCommandDelete")
            .on("click", async (e: any) => {
                e.preventDefault();
                const idDel = parseInt($(e.currentTarget).attr("data-rif-id") || "0");
                const lottoId = parseInt($(e.currentTarget).attr("data-rif-lottoId") || "0");

                if (await UI.confirm("Attenzione", "Sei sicuro di volere eliminare l'allegato?", "")) {
                    await that.DeleteDocumento(idDel, lottoId);
                }
            });

    }

    private async InviaMail(data: any): Promise<void> {
        try {
            const url = window.BaseUrlWeb + 'Venditore/MailperCaricaDoc';
            await $.ajaxWithCredentials({
                method: 'POST',
                url: url,
                data: JSON.stringify({
                    tipoAllegato: data[0]["TipoAllegato"].Descrizione,
                    Lotto: data[0]["LottoId"],
                    NomeFile: data[0]["NomeFile"]
                }),
                contentType: 'application/json',
                cache: false
            });
        } catch (error) {
            console.error("Errore durante l'invio della mail:", error);
        }
    }

    private async DeleteDocumento(id: number, lottoId: number): Promise<void> {
        if (id && lottoId) {
            try {
                let result = await this.auth.fetchWithAuth(
                    `POST ${window.BaseUrlWeb}Venditore/DeleteAllegato?allegatoId=${id}&lottoId=${lottoId}`);
                if (result !== "OK") {
                    UI.confirmOneButton("", result);
                } else {
                    $("#tbDocumenti").find($("#trrow" + id)).remove();
                }
            } catch (error) {
                console.info(handleError(error));
                return;
            }
        }
    }
}

export default Documenti;
